var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIowa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.753,133.495c-1.353-1.081-15.959-14.875-16.498-16.228c-0.192-0.478-0.419-1.67-0.737-3.078 c-0.581-2.572-1.477-5.881-3.051-6.93c-2.434-1.623-11.63-1.352-14.604-8.114c-2.976-6.762,1.353-15.959,1.081-20.015 c-0.271-4.057-4.958-2.524-7.211-11.54l-47.806,0.765l-132.151,2.12h-7.033v11.901l7.033,2.175l-7.033,23.789l5.411,12.444 c0,0,8.711,32.426,15.128,56.816c1.584,6.021,3.025,11.548,4.165,15.979c1.146,4.46,1.984,7.813,2.343,9.428 c0.806,3.627,1.988,7.254,3.153,10.375l121.626-3.443l25.065-0.71c0,0,9.079,10.34,10.919,10.562c0.108-0.012,0.17-0.014,0.17-0.014 c1.352-0.541,2.164-10.548,2.164-10.548l8.655-6.491v-6.76l4.87-5.142v-8.113c0,0-6.223-4.327-5.682-5.952 c0.54-1.62,1.895-7.843,3.786-8.383c1.896-0.541,21.366-7.303,22.99-14.607C255.131,146.477,258.104,134.578,256.753,133.495z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIowa);
export default __webpack_public_path__ + "static/media/iowa.d9d98447e1948d406a8c34a6b8fe7150.svg";
export { ForwardRef as ReactComponent };